import { Component, OnInit, ElementRef, ViewChild } from '@angular/core'
import { LoginService } from '../services/login.service'
import { FormBuilder, FormGroup, Validators } from '@angular/forms'
import { ActivatedRoute, Router } from '@angular/router'
import { HttpErrorResponse } from '@angular/common/http'
import { BehaviorSubject } from 'rxjs'

@Component({
    selector: 'app-agent-link',
    templateUrl: './agent-link.component.html',
    styleUrls: ['./agent-link.component.scss'],
    standalone: false
})
export class AgentLinkComponent implements OnInit {
  @ViewChild('intlPhone', { static: false }) intlPhoneRef: ElementRef

  constructor(
    private formBuilder: FormBuilder,
    private loginService: LoginService,
    private route: ActivatedRoute,
    private router: Router,
  ) {}

  createForm: FormGroup
  submitted = false

  telInputRef: any

  userCreationSucces = false
  userCreationFail = false

  userCreated: string = ''

  isWaitingResponse = new BehaviorSubject(false)

  email: string = ''
  code: string = ''

  validSignUpCode = false
  invalidSignUpCode = false

  ngOnInit(): void {
    this.email = this.getEmailFromUrl()
    this.code = this.getCodeFromUrl()

    this.validateSignUp(this.email, this.code)

    this.createForm = this.formBuilder.group(
      {
        firstname: ['', Validators.required],
        lastname: ['', Validators.required],
        identifier: [this.email, [Validators.required, Validators.email]],
        password: ['', [Validators.required, Validators.minLength(8)]],
        confirmPassword: ['', Validators.required],
        phonenumber: ['', Validators.required],
      },
      {
        validator: this.ComparePassword('password', 'confirmPassword'),
      },
    )
  }

  ComparePassword(controlName: string, matchingControlName: string) {
    return (formGroup: FormGroup) => {
      const control = formGroup.controls[controlName]
      const matchingControl = formGroup.controls[matchingControlName]

      if (matchingControl.errors && !matchingControl.errors.mustMatch) {
        return
      }

      if (control.value !== matchingControl.value) {
        matchingControl.setErrors({ mustMatch: true })
      } else {
        matchingControl.setErrors(null)
      }
    }
  }

  createAgent() {
    this.submitted = true
    this.isWaitingResponse.next(true)

    this.userCreationFail = false
    this.userCreationSucces = false

    if (this.createForm.invalid) {
      return
    }

    if (this.createForm.controls.phonenumber.value) {
      if (!this.createForm.controls.phonenumber.value.includes('+')) {
        const code = '+' + this.telInputRef.s.dialCode
        this.createForm.controls['phonenumber'].setValue(code + this.createForm.controls.phonenumber.value.replace(/\s/g, ''))
      }
    }

    this.loginService.createInternalUserSignUp(this.email, this.code, this.f.firstname.value, this.f.lastname.value, this.f.password.value, this.f.phonenumber.value, 'AG.Web.Internal').subscribe(
      (res) => {
        this.validSignUpCode = false
        this.userCreationSucces = true
        this.userCreated = res.Identifier
      },
      (err) => {
        this.isWaitingResponse.next(false)
        if (err instanceof HttpErrorResponse) {
          this.userCreationFail = true
        }
      },
    )
  }

  private getEmailFromUrl(): string {
    return this.route.snapshot.paramMap.get('email').toLowerCase()
  }

  private getCodeFromUrl(): string {
    return this.route.snapshot.paramMap.get('code')
  }

  validateSignUp(email: string, code: string) {
    this.validSignUpCode = false
    this.invalidSignUpCode = false
    this.loginService.confirmSignUpInternalUser(email, code).subscribe(
      (res) => {
        this.validSignUpCode = true
      },
      (err) => {
        if (err instanceof HttpErrorResponse) {
          this.invalidSignUpCode = true
        }
      },
    )
  }

  get f() {
    return this.createForm.controls
  }

  telInputObject(obj) {
    this.telInputRef = obj
  }

  getNumber($event) {
    this.createForm.patchValue({
      phonenumber: $event,
    })
  }

  hasError(isValid) {
    if (!isValid) {
      this.createForm.controls.phonenumber.setErrors({ invalidPhoneNumber: true })
    }
  }

  onCountryChange(countryData) {
    if (countryData.priority === 0) {
      const phoneNumber = this.intlPhoneRef.nativeElement.value
      if (phoneNumber[1] === '1' || phoneNumber[1] === '7') {
        this.createForm.patchValue({
          phonenumber: phoneNumber.replace(`+${countryData.dialCode}`, ''),
        })
      } else if (phoneNumber.length > 1 && phoneNumber[1] !== '1') {
        this.createForm.patchValue({
          phonenumber: phoneNumber.replace(`+${countryData.dialCode}`, ''),
        })
      }
    } else {
      this.createForm.controls.phonenumber.setErrors(undefined)
    }
  }

  gotoLogin() {
    this.router.navigate(['/login'])
  }
}
